import Agent from '../api/AnonymousAgent'

import { CancelTokenSource } from 'axios'

class MegamenuContentService {
  getFooterContentLinks = async (source?: CancelTokenSource) => {
    return Agent.GovCMS.getFooterContentLinks(source)
  }

  getHeaderContentLinks = async (source?: CancelTokenSource) => {
    return Agent.GovCMS.getHeaderContentLinks(source)
  }
}

export default new MegamenuContentService()
